// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__wH2eC","col":"styles_col__29FYw"};